import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: Number }

  connect() {
    if (localStorage.getItem(this.#storageKey)) {
      this.#collapse()
    } else {
      this.#expand()
    }
  }

  hide() {
    localStorage.setItem(this.#storageKey, "1")
    this.#collapse()
  }

  show() {
    localStorage.removeItem(this.#storageKey)
    this.#expand()
  }

  get #storageKey() {
    return `infobox_dismissed_${this.idValue}`
  }

  #collapse() {
    this.element.querySelector(".callout-info")?.classList.add("hidden")
    this.element.querySelector(".js-info-button")?.classList.remove("hidden")
  }

  #expand() {
    this.element.querySelector(".callout-info")?.classList.remove("hidden")
    this.element.querySelector(".js-info-button")?.classList.add("hidden")
  }
}
